import styled from '@emotion/styled';
import { Box, Stack } from '@mui/material';

export const Wrapper = styled(Box)`
  position: absolute;
  overflow: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  max-width: 90%;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;
`;

export const HeaderWrapper = styled(Stack)`
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CloseButtonWrapper = styled(Box)`
  display: flex;
  justify-content: end;
  margin-top: 16px;
  gap: 8px;
`;

export const ContentWrapper = styled.div`
  padding: 20px 0;
`;

export const StyledNote = styled.p`
  margin-top: 20px;
  font-style: italic;
  font-size: 12px;
`;
